module.exports = __webpack_public_path__ + "media/images/ringrevenue/control_play_blue-c4f69bef677c61a6cf1175265625fed8.png";